/* ============================================================================
FILE: po-katupirsia9-couleur-espace-texts-fr-en-es-20260318.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK9CouleurEspaceTextsFR_EN_ES_20260318
ROOT: .po-k9-section[data-po-k9]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K9_COULEUR_ESPACE_TEXTS_20260318__) return;
  window.__PO_K9_COULEUR_ESPACE_TEXTS_20260318__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k9-section[data-po-k9="couleur_espace"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Àṣẹxel’Or",
      "Âṣẹxel’Or",
      "Couleur-Temps",
      "Couleur-Espace",
      "Couleur-Matière",
      "Triade Chromatique Posœnnoïale",
      "Champ d’or",
      "Champ d’Or",
      "Champ et structures dorés",
      "Couleurs et lois d’or",
      "Loi d’or",
      "Logique doré",
      "Amplitude dorée",
      "Architecture dorée",
      "Axe doré",
      "Sceau d’Équiphase",
      "Sceau de Syntonie",
      "Katûvýs",
      "Katûvýsissence",
      "Isqun",
      "Threnisqun",
      "Ennéagone",
      "Balakallpa",
      "Numéris",
      "Année posœnnoïale",
      "Année posœnnoïale (AP)",
      "Épagomènes",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux",
      "Δτ",
      "Φ₄₉₂",
      "ρₘ",
      "492 Hz",
      "K9",
      "AP",
      "Uniforme",
      "Lissé",
      "Pulsé",
      "Ēkuphasa",
      "Syntōnēa",
      "Aísthēra",
      "Anēporon",
      "Ifẹ̀riya",
      "Ayeẹmīnê",
      "Ọ̀rōyuyān",
      "Yuyarīnâ",
      "Œndomarê",
      "Éther",
      "Air",
      "Feu",
      "Eau",
      "Terre"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    return new RegExp(parts.join("|"), "g");
  }

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";

    var rx = buildProtectMatcher();
    return src.replace(rx, function (m) {
      return '<span translate="no" class="po-lex-protect">' + m + "</span>";
    });
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setImg(el, data) {
    if (!el) return;

    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";

    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
    } else {
      el.removeAttribute("src");
      el.setAttribute("hidden", "");
      el.alt = "";
    }
  }

  function syncChipBlock(root, slotName) {
    var label = root.querySelector('[data-po-slot="' + slotName + '"]');
    var img = root.querySelector('[data-po-slot="' + slotName + '_img"]');
    var block = null;

    if (label && label.closest) block = label.closest(".po-axis-chipblock");
    if (!block && img && img.closest) block = img.closest(".po-axis-chipblock");
    if (!block) return;

    var hasLabel = !!(label && clampStr(label.textContent).trim());
    var hasImg = !!(img && clampStr(img.getAttribute("src")).trim() && !img.hasAttribute("hidden"));

    if (hasLabel || hasImg) block.removeAttribute("hidden");
    else block.setAttribute("hidden", "");
  }

  var CONTENT = {
    fr: {
      title: "Couleur-Espace",
      kicker: "Deuxième porte de la Triade Chromatique Posœnnoïale — la propagation du réel, là où la couleur fait advenir un lieu sans le fermer.",

      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-espace_conceptuel.png?v=1773257476",
        alt: "Idéogramme conceptuel de Couleur-Espace"
      },

      h_def: "Définition canonique",

      chip_1: "Idéogramme conceptuel",
      chip_1_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-espace_conceptuel.png?v=1773257476",
        alt: "Idéogramme conceptuel de Couleur-Espace"
      },

      chip_2: "Idéogramme fonctionnel",
      chip_2_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-espace_fonctionnel.png?v=1773257476",
        alt: "Idéogramme fonctionnel de Couleur-Espace"
      },

      chip_3: "Champ et structures dorés",
      chip_3_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/champs_et_structures_dores.png?v=1773257097",
        alt: "Schéma Champ et structures dorés"
      },

      def_short:
        "<strong>Couleur-Espace</strong> désigne la manière dont la couleur se donne comme propagation, relation et champ de syntonie : non décor d’un lieu déjà là, mais organisation perceptible d’un espace en train d’advenir, dans la continuité de la <strong>Katûvýs</strong>, sous l’ajustement de l’<strong>Isqun</strong> et la mémoire active du <strong>Threnisqun</strong>.",

      def_long:
        "<p>Dans la <strong>Triade Chromatique Posœnnoïale</strong>, <strong>Couleur-Espace</strong> constitue la porte de propagation : la couleur n’y vient pas occuper un espace donné, elle participe à son apparition.</p>" +
        "<p>Elle organise des distances sans les figer, crée des proximités sans les enfermer, ouvre des passages sans les stabiliser. Le champ se modifie à mesure que la couleur s’y déploie.</p>" +
        "<p><strong>Couleur-Espace</strong> ne forme pourtant pas un domaine séparé. Ce qui se propage dans l’espace engage déjà la pulsation de <strong>Couleur-Temps</strong> et prépare déjà la mémoire de <strong>Couleur-Matière</strong>. La couleur ne décrit donc pas un lieu : elle le fait advenir.</p>",

      h_grid: "Structure vibratoire",
      grid_type_label: "Type",
      grid_type_value: "Deuxième porte chromatique de la triade : propagation / syntonie du champ par organisation relationnelle du visible",
      grid_freq_label: "Valeurs-clés",
      grid_freq_value: "Katûvýs : champ matriciel · Isqun : régulation des intensités · Threnisqun : mémoire des orientations · Φ₄₉₂ : fonction d’accord · Sceau d’Équiphase : redistribution respiratoire",
      grid_scope_label: "Axes et déploiement",
      grid_scope_value:
        "<ul>" +
        "<li>Champ de référence : <strong>Katûvýs</strong></li>" +
        "<li>Mouvement : propagation, orientation, diffusion relationnelle</li>" +
        "<li>Régulations actives : <strong>Isqun</strong> ajuste ; <strong>Threnisqun</strong> retient la trace</li>" +
        "<li>Profils lisibles : <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong></li>" +
        "<li>Formule opérative : <strong>la lumière se déploie en relation</strong></li>" +
        "</ul>",

      h_intro: "Le champ en train d’advenir",
      p_intro:
        "<p>Dans l’expérience posœnnoïale, l’espace n’apparaît jamais comme une étendue vide où la couleur viendrait simplement se poser. Il se révèle dans la relation même, dans la manière dont une teinte ouvre, ferme, rapproche, éloigne, retient ou diffuse.</p>" +
        "<p>Le regard n’y suit pas un trajet linéaire. Il circule, s’attarde, revient, se perd parfois, puis retrouve une orientation. Cette circulation naît de la manière dont la couleur distribue les tensions du champ.</p>" +
        "<p><strong>Couleur-Espace</strong> formalise ainsi une propagation du réel : elle relie lumière, durée, matière, mémoire et perception dans un même organisme de syntonie.</p>",

      h_actions: "Fonctionnement opératif",
      actions:
        "<ol>" +
        "<li>Lire le champ non comme contenant, mais comme relation en train de se former.</li>" +
        "<li>Observer les zones de condensation, de diffusion et d’équilibre sans les transformer en codes fixes.</li>" +
        "<li>Reconnaître comment l’<strong>Isqun</strong> ajuste les intensités du visible et comment le <strong>Threnisqun</strong> en maintient la mémoire active.</li>" +
        "<li>Rapporter chaque orientation à une propagation vivante, jamais à une géométrie close.</li>" +
        "<li>Relier ce qui se déploie dans l’espace au battement de <strong>Couleur-Temps</strong> et à la rétention de <strong>Couleur-Matière</strong>.</li>" +
        "</ol>",

      h_phrase: "Phrase opérative",
      phrase:
        "« Couleur-Espace : la couleur ne vient pas occuper un lieu, elle le fait advenir dans la relation. »",

      h_table: "Tableau d’usage",
      table_head_1: "Profil",
      table_head_2: "Climat chromatique",
      table_head_3: "Régime et manifestation",
      table_rows:
        "<tr><td><strong>Uniforme</strong></td><td>diffusions équilibrées, gris chauds, verts accordés, respirations stables</td><td>Champ posé ; lisibilité continue ; propagation égalisée ; ancrage spatial, tenue du regard, stabilisation de la relation</td></tr>" +
        "<tr><td><strong>Lissé</strong></td><td>halos bleus, violets, turquoises, transparences, glissements de lumière</td><td>Expansion spiralée ; circulation fluide ; syntonie ouverte ; passages, déploiement, mise en relation du champ</td></tr>" +
        "<tr><td><strong>Pulsé</strong></td><td>condensations rouge-cuivre, ors denses, tensions d’ombre, foyers d’intensité</td><td>Seuil spatial ; resserrement local ; accentuation des tensions ; points d’appel, basculements, émergence de trajectoires</td></tr>",

      h_entite: "Position dans la triade",
      entite_kicker: "Espace — propagation — deuxième porte",
      entite_body:
        "<p>Dans la <strong>Triade Chromatique Posœnnoïale</strong>, <strong>Couleur-Espace</strong> correspond à la propagation. Elle prolonge ce qui bat dans <strong>Couleur-Temps</strong> et prépare ce qui se retiendra dans <strong>Couleur-Matière</strong>.</p>" +
        "<p>Son champ de référence est la <strong>Katûvýs</strong>, dans laquelle la couleur agit comme trame respirante. L’<strong>Isqun</strong> redistribue les charges du champ ; le <strong>Threnisqun</strong> conserve la mémoire des orientations traversées.</p>" +
        "<p>Ainsi, l’espace cesse d’être un simple lieu. Il devient mode de propagation du réel, champ de syntonie, organisme d’apparition.</p>",

      h_ritual: "Rituel d’activation",
      ritual_name_label: "Nom",
      ritual_name_value: "Lecture du champ chromatique",
      ritual_steps:
        "<ol>" +
        "<li>Se placer devant une œuvre, une lumière, un paysage ou un écran, en laissant d’abord le champ se former sans le nommer.</li>" +
        "<li>Repérer les orientations du regard : zones d’appel, passages, respirations, condensations, ouvertures.</li>" +
        "<li>Reconnaître si le champ tend vers un profil <strong>Uniforme</strong>, <strong>Lissé</strong> ou <strong>Pulsé</strong>.</li>" +
        "<li>Laisser la couleur fonctionner comme trame de circulation, et non comme simple surface localisable.</li>" +
        "<li>Clore par la phrase opérative afin de restituer à l’espace sa qualité relationnelle et respiratoire.</li>" +
        "</ol>",

      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
        "<li>Quand une couleur reconfigure la perception d’un lieu avant même toute interprétation</li>" +
        "<li>Dans les <strong>Accords Posœnnoïaux</strong>, où la propagation du champ devient syntonie partagée</li>" +
        "<li>Dans les œuvres où le regard circule, hésite, revient et découvre un lieu en train de se former</li>" +
        "<li>Dans les atmosphères de seuil, de halo, de diffusion ou de condensation spatiale</li>" +
        "<li>Quand l’espace cesse d’être décor pour devenir relation vivante entre lumière, mémoire et présence</li>" +
        "</ul>",

      h_syntony: "Syntonies K9",
      syntony:
        "<ul>" +
        "<li><strong>Katûvýs</strong> — champ matriciel de propagation, de tension et de syntonie</li>" +
        "<li><strong>Isqun</strong> — redistribution des intensités, maintien de la lisibilité du champ</li>" +
        "<li><strong>Threnisqun</strong> — mémoire active des orientations, des passages et des tensions traversées</li>" +
        "<li><strong>Sceau d’Équiphase</strong> — respiration de l’écart, lisibilité des profils <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong></li>" +
        "<li><strong>Couleur-Temps</strong> — battement préalable dont l’espace propage la dynamique</li>" +
        "<li><strong>Couleur-Matière</strong> — mémoire dense de ce qui s’est distribué dans le champ</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept",
      hint_fold: "déplier"
    },

    en: {
      title: "Couleur-Espace",
      kicker: "Deuxième porte de la <span translate=\"no\" class=\"po-lex-protect\">Triade Chromatique Posœnnoïale</span> — the propagation of the real, where color brings a place into being without closing it.",

      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-espace_conceptuel.png?v=1773257476",
        alt: "Conceptual ideogram of Couleur-Espace"
      },

      h_def: "Canonical definition",

      chip_1: "Conceptual ideogram",
      chip_1_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-espace_conceptuel.png?v=1773257476",
        alt: "Conceptual ideogram of Couleur-Espace"
      },

      chip_2: "Functional ideogram",
      chip_2_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-espace_fonctionnel.png?v=1773257476",
        alt: "Functional ideogram of Couleur-Espace"
      },

      chip_3: "Champ et structures dorés",
      chip_3_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/champs_et_structures_dores.png?v=1773257097",
        alt: "Diagram of Champ et structures dorés"
      },

      def_short:
        "<strong>Couleur-Espace</strong> designates the way color is given as propagation, relation, and field of syntony: not the décor of an already existing place, but the perceptible organization of a space coming into being, within the continuity of the <strong>Katûvýs</strong>, under the adjustment of <strong>Isqun</strong> and the active memory of <strong>Threnisqun</strong>.",

      def_long:
        "<p>Within the <strong>Triade Chromatique Posœnnoïale</strong>, <strong>Couleur-Espace</strong> constitutes the gate of propagation: color does not come to occupy a given space there; it participates in its appearance.</p>" +
        "<p>It organizes distances without fixing them, creates proximities without enclosing them, opens passages without stabilizing them. The field changes as color unfolds within it.</p>" +
        "<p><strong>Couleur-Espace</strong> does not, however, form a separate domain. What propagates in space already engages the pulsation of <strong>Couleur-Temps</strong> and already prepares the memory of <strong>Couleur-Matière</strong>. Color therefore does not describe a place: it brings it into being.</p>",

      h_grid: "Vibratory structure",
      grid_type_label: "Type",
      grid_type_value: "Second chromatic gate of the triad: propagation / syntony of the field through the relational organization of the visible",
      grid_freq_label: "Key values",
      grid_freq_value: "Katûvýs: matrix field · Isqun: regulation of intensities · Threnisqun: memory of orientations · Φ₄₉₂: tuning function · Sceau d’Équiphase: respiratory redistribution",
      grid_scope_label: "Axes and deployment",
      grid_scope_value:
        "<ul>" +
        "<li>Reference field: <strong>Katûvýs</strong></li>" +
        "<li>Movement: propagation, orientation, relational diffusion</li>" +
        "<li>Active regulations: <strong>Isqun</strong> adjusts; <strong>Threnisqun</strong> retains the trace</li>" +
        "<li>Readable profiles: <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong></li>" +
        "<li>Operative formula: <strong>light unfolds in relation</strong></li>" +
        "</ul>",

      h_intro: "The field coming into being",
      p_intro:
        "<p>In posœnnoïal experience, space never appears as an empty expanse upon which color would simply be placed. It reveals itself in the relation itself, in the way a hue opens, closes, draws nearer, moves away, retains, or diffuses.</p>" +
        "<p>The gaze does not follow a linear path there. It circulates, lingers, returns, sometimes gets lost, then finds an orientation again. That circulation arises from the way color distributes the tensions of the field.</p>" +
        "<p><strong>Couleur-Espace</strong> thus formalizes a propagation of the real: it binds light, duration, matter, memory, and perception within a single organism of syntony.</p>",

      h_actions: "Operative functioning",
      actions:
        "<ol>" +
        "<li>Read the field not as a container, but as a relation in the process of forming.</li>" +
        "<li>Observe zones of condensation, diffusion, and balance without turning them into fixed codes.</li>" +
        "<li>Recognize how <strong>Isqun</strong> adjusts the intensities of the visible and how <strong>Threnisqun</strong> maintains their active memory.</li>" +
        "<li>Relate each orientation to a living propagation, never to a closed geometry.</li>" +
        "<li>Connect what unfolds in space to the beat of <strong>Couleur-Temps</strong> and to the retention of <strong>Couleur-Matière</strong>.</li>" +
        "</ol>",

      h_phrase: "Operative phrase",
      phrase:
        "“Couleur-Espace: color does not come to occupy a place; it brings it into being through relation.”",

      h_table: "Usage table",
      table_head_1: "Profile",
      table_head_2: "Chromatic climate",
      table_head_3: "Regime and manifestation",
      table_rows:
        "<tr><td><strong>Uniforme</strong></td><td>balanced diffusions, warm greys, tuned greens, stable respirations</td><td>Settled field; continuous readability; equalized propagation; spatial anchoring, steadiness of the gaze, stabilization of relation</td></tr>" +
        "<tr><td><strong>Lissé</strong></td><td>blue halos, violets, turquoises, transparencies, gliding light</td><td>Spiral expansion; fluid circulation; open syntony; passages, unfolding, putting the field into relation</td></tr>" +
        "<tr><td><strong>Pulsé</strong></td><td>red-copper condensations, dense golds, shadow tensions, centers of intensity</td><td>Spatial threshold; local tightening; accentuation of tensions; points of call, shifts, emergence of trajectories</td></tr>",

      h_entite: "Position in the triad",
      entite_kicker: "Space — propagation — second gate",
      entite_body:
        "<p>Within the <strong>Triade Chromatique Posœnnoïale</strong>, <strong>Couleur-Espace</strong> corresponds to propagation. It prolongs what beats within <strong>Couleur-Temps</strong> and prepares what will be retained in <strong>Couleur-Matière</strong>.</p>" +
        "<p>Its reference field is the <strong>Katûvýs</strong>, within which color acts as a breathing weave. <strong>Isqun</strong> redistributes the charges of the field; <strong>Threnisqun</strong> preserves the memory of the orientations crossed.</p>" +
        "<p>Thus space ceases to be a simple place. It becomes a mode of propagation of the real, a field of syntony, an organism of appearance.</p>",

      h_ritual: "Activation ritual",
      ritual_name_label: "Name",
      ritual_name_value: "Reading the chromatic field",
      ritual_steps:
        "<ol>" +
        "<li>Stand before an artwork, a light, a landscape, or a screen, letting the field form first without naming it.</li>" +
        "<li>Identify the orientations of the gaze: zones of call, passages, respirations, condensations, openings.</li>" +
        "<li>Recognize whether the field tends toward a <strong>Uniforme</strong>, <strong>Lissé</strong>, or <strong>Pulsé</strong> profile.</li>" +
        "<li>Let color function as a weave of circulation, rather than as a merely localizable surface.</li>" +
        "<li>Close with the operative phrase so that space may recover its relational and breathing quality.</li>" +
        "</ol>",

      h_moments: "Privileged moments",
      moments:
        "<ul>" +
        "<li>When a color reconfigures the perception of a place before any interpretation</li>" +
        "<li>In <strong>Accords Posœnnoïaux</strong>, where the propagation of the field becomes shared syntony</li>" +
        "<li>In works where the gaze circulates, hesitates, returns, and discovers a place in the process of forming</li>" +
        "<li>In atmospheres of threshold, halo, diffusion, or spatial condensation</li>" +
        "<li>When space ceases to be décor and becomes a living relation between light, memory, and presence</li>" +
        "</ul>",

      h_syntony: "K9 syntonies",
      syntony:
        "<ul>" +
        "<li><strong>Katûvýs</strong> — matrix field of propagation, tension, and syntony</li>" +
        "<li><strong>Isqun</strong> — redistribution of intensities, maintenance of the field’s readability</li>" +
        "<li><strong>Threnisqun</strong> — active memory of orientations, passages, and traversed tensions</li>" +
        "<li><strong>Sceau d’Équiphase</strong> — breathing of the interval, readability of the <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong> profiles</li>" +
        "<li><strong>Couleur-Temps</strong> — prior beat whose dynamic space propagates</li>" +
        "<li><strong>Couleur-Matière</strong> — dense memory of what has been distributed in the field</li>" +
        "</ul>",

      cta_translate: "Suggest a translation of the concept",
      hint_fold: "expand"
    },

    es: {
      title: "Couleur-Espace",
      kicker: "Deuxième porte de la <span translate=\"no\" class=\"po-lex-protect\">Triade Chromatique Posœnnoïale</span> — la propagación de lo real, donde el color hace advenir un lugar sin cerrarlo.",

      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-espace_conceptuel.png?v=1773257476",
        alt: "Ideograma conceptual de Couleur-Espace"
      },

      h_def: "Definición canónica",

      chip_1: "Ideograma conceptual",
      chip_1_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-espace_conceptuel.png?v=1773257476",
        alt: "Ideograma conceptual de Couleur-Espace"
      },

      chip_2: "Ideograma funcional",
      chip_2_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-espace_fonctionnel.png?v=1773257476",
        alt: "Ideograma funcional de Couleur-Espace"
      },

      chip_3: "Champ et structures dorés",
      chip_3_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/champs_et_structures_dores.png?v=1773257097",
        alt: "Esquema Champ et structures dorés"
      },

      def_short:
        "<strong>Couleur-Espace</strong> designa la manera en que el color se da como propagación, relación y campo de sintonía: no decoración de un lugar ya dado, sino organización perceptible de un espacio que adviene, en la continuidad de la <strong>Katûvýs</strong>, bajo el ajuste del <strong>Isqun</strong> y la memoria activa del <strong>Threnisqun</strong>.",

      def_long:
        "<p>En la <strong>Triade Chromatique Posœnnoïale</strong>, <strong>Couleur-Espace</strong> constituye la puerta de la propagación: el color no viene allí a ocupar un espacio dado, participa en su aparición.</p>" +
        "<p>Organiza distancias sin fijarlas, crea proximidades sin encerrarlas, abre pasajes sin estabilizarlos. El campo se modifica a medida que el color se despliega en él.</p>" +
        "<p><strong>Couleur-Espace</strong> no forma, sin embargo, un dominio separado. Lo que se propaga en el espacio compromete ya la pulsación de <strong>Couleur-Temps</strong> y prepara ya la memoria de <strong>Couleur-Matière</strong>. El color, por tanto, no describe un lugar: lo hace advenir.</p>",

      h_grid: "Estructura vibratoria",
      grid_type_label: "Tipo",
      grid_type_value: "Segunda puerta cromática de la tríada: propagación / sintonía del campo por organización relacional de lo visible",
      grid_freq_label: "Valores clave",
      grid_freq_value: "Katûvýs: campo matricial · Isqun: regulación de intensidades · Threnisqun: memoria de orientaciones · Φ₄₉₂: función de acuerdo · Sceau d’Équiphase: redistribución respiratoria",
      grid_scope_label: "Ejes y despliegue",
      grid_scope_value:
        "<ul>" +
        "<li>Campo de referencia: <strong>Katûvýs</strong></li>" +
        "<li>Movimiento: propagación, orientación, difusión relacional</li>" +
        "<li>Regulaciones activas: <strong>Isqun</strong> ajusta; <strong>Threnisqun</strong> retiene la huella</li>" +
        "<li>Perfiles legibles: <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong></li>" +
        "<li>Fórmula operativa: <strong>la luz se despliega en relación</strong></li>" +
        "</ul>",

      h_intro: "El campo en proceso de advenir",
      p_intro:
        "<p>En la experiencia posœnnoïale, el espacio nunca aparece como una extensión vacía sobre la que el color vendría simplemente a posarse. Se revela en la relación misma, en la manera en que un tono abre, cierra, acerca, aleja, retiene o difunde.</p>" +
        "<p>La mirada no sigue allí un trayecto lineal. Circula, se demora, vuelve, a veces se pierde, y luego recupera una orientación. Esa circulación nace de la manera en que el color distribuye las tensiones del campo.</p>" +
        "<p><strong>Couleur-Espace</strong> formaliza así una propagación de lo real: une luz, duración, materia, memoria y percepción en un mismo organismo de sintonía.</p>",

      h_actions: "Funcionamiento operativo",
      actions:
        "<ol>" +
        "<li>Leer el campo no como contenedor, sino como relación en proceso de formación.</li>" +
        "<li>Observar las zonas de condensación, difusión y equilibrio sin transformarlas en códigos fijos.</li>" +
        "<li>Reconocer cómo el <strong>Isqun</strong> ajusta las intensidades de lo visible y cómo el <strong>Threnisqun</strong> mantiene su memoria activa.</li>" +
        "<li>Relacionar cada orientación con una propagación viva, nunca con una geometría cerrada.</li>" +
        "<li>Vincular lo que se despliega en el espacio con el latido de <strong>Couleur-Temps</strong> y con la retención de <strong>Couleur-Matière</strong>.</li>" +
        "</ol>",

      h_phrase: "Frase operativa",
      phrase:
        "« Couleur-Espace : el color no viene a ocupar un lugar, lo hace advenir en la relación. »",

      h_table: "Tabla de uso",
      table_head_1: "Perfil",
      table_head_2: "Clima cromático",
      table_head_3: "Régimen y manifestación",
      table_rows:
        "<tr><td><strong>Uniforme</strong></td><td>difusiones equilibradas, grises cálidos, verdes acordados, respiraciones estables</td><td>Campo asentado; legibilidad continua; propagación igualada; anclaje espacial, sostén de la mirada, estabilización de la relación</td></tr>" +
        "<tr><td><strong>Lissé</strong></td><td>halos azules, violetas, turquesas, transparencias, deslizamientos de luz</td><td>Expansión espiral; circulación fluida; sintonía abierta; pasajes, despliegue, puesta en relación del campo</td></tr>" +
        "<tr><td><strong>Pulsé</strong></td><td>condensaciones rojo-cobre, oros densos, tensiones de sombra, focos de intensidad</td><td>Umbral espacial; estrechamiento local; acentuación de tensiones; puntos de llamada, basculamientos, emergencia de trayectorias</td></tr>",

      h_entite: "Posición en la tríada",
      entite_kicker: "Espacio — propagación — segunda puerta",
      entite_body:
        "<p>En la <strong>Triade Chromatique Posœnnoïale</strong>, <strong>Couleur-Espace</strong> corresponde a la propagación. Prolonga lo que late en <strong>Couleur-Temps</strong> y prepara lo que se retendrá en <strong>Couleur-Matière</strong>.</p>" +
        "<p>Su campo de referencia es la <strong>Katûvýs</strong>, en la que el color actúa como trama respirante. El <strong>Isqun</strong> redistribuye las cargas del campo; el <strong>Threnisqun</strong> conserva la memoria de las orientaciones atravesadas.</p>" +
        "<p>Así, el espacio deja de ser un simple lugar. Se vuelve modo de propagación de lo real, campo de sintonía, organismo de aparición.</p>",

      h_ritual: "Ritual de activación",
      ritual_name_label: "Nombre",
      ritual_name_value: "Lectura del campo cromático",
      ritual_steps:
        "<ol>" +
        "<li>Situarse ante una obra, una luz, un paisaje o una pantalla, dejando primero que el campo se forme sin nombrarlo.</li>" +
        "<li>Identificar las orientaciones de la mirada: zonas de llamada, pasajes, respiraciones, condensaciones, aperturas.</li>" +
        "<li>Reconocer si el campo tiende hacia un perfil <strong>Uniforme</strong>, <strong>Lissé</strong> o <strong>Pulsé</strong>.</li>" +
        "<li>Dejar que el color funcione como trama de circulación, y no como simple superficie localizable.</li>" +
        "<li>Cerrar con la frase operativa para devolver al espacio su cualidad relacional y respiratoria.</li>" +
        "</ol>",

      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
        "<li>Cuando un color reconfigura la percepción de un lugar antes de toda interpretación</li>" +
        "<li>En los <strong>Accords Posœnnoïaux</strong>, donde la propagación del campo se vuelve sintonía compartida</li>" +
        "<li>En obras donde la mirada circula, duda, vuelve y descubre un lugar en formación</li>" +
        "<li>En atmósferas de umbral, halo, difusión o condensación espacial</li>" +
        "<li>Cuando el espacio deja de ser decorado para convertirse en relación viva entre luz, memoria y presencia</li>" +
        "</ul>",

      h_syntony: "Sintonías K9",
      syntony:
        "<ul>" +
        "<li><strong>Katûvýs</strong> — campo matricial de propagación, tensión y sintonía</li>" +
        "<li><strong>Isqun</strong> — redistribución de intensidades, mantenimiento de la legibilidad del campo</li>" +
        "<li><strong>Threnisqun</strong> — memoria activa de orientaciones, pasajes y tensiones atravesadas</li>" +
        "<li><strong>Sceau d’Équiphase</strong> — respiración del intervalo, legibilidad de los perfiles <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong></li>" +
        "<li><strong>Couleur-Temps</strong> — latido previo cuya dinámica el espacio propaga</li>" +
        "<li><strong>Couleur-Matière</strong> — memoria densa de lo que se ha distribuido en el campo</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept",
      hint_fold: "desplegar"
    }
  };

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function getHintNodes(root) {
    return root ? root.querySelectorAll(".po-lex-summary__hint:not([data-po-slot])") : [];
  }

  function applyHintText(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;
    var hint = c.hint_fold || "";
    var nodes = getHintNodes(root);
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = hint;
  }

  /* ==========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
     ========================================================================== */
  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    lang: "fr",
    voice: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang) {
    var L = normLang(lang);
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function ensureAudioStyles() {
    if (document.getElementById("po-k9-couleur-espace-audio-styles")) return;
    var st = document.createElement("style");
    st.id = "po-k9-couleur-espace-audio-styles";
    st.textContent =
      '.po-axis-audio-wrap{display:flex;justify-content:center;align-items:center;margin:10px 0 12px;}' +
      '.po-axis-audio-btn{appearance:none;border:1px solid rgba(184,134,11,.45);background:rgba(255,255,255,.72);color:inherit;border-radius:999px;padding:8px 12px;font:inherit;font-size:12px;line-height:1.1;cursor:pointer;box-shadow:0 0 0 1px rgba(184,134,11,.12);}' +
      '.po-axis-audio-btn.is-playing{border-color:rgba(31,122,58,.55);box-shadow:0 0 0 1px rgba(31,122,58,.16),0 8px 18px rgba(31,122,58,.12);font-weight:700;}'+
      '.po-lex-summary .po-axis-audio-wrap{margin:0;justify-content:flex-end;}';
    document.head.appendChild(st);
  }

  function getTextValue(el) {
    if (!el) return "";
    var txt = "";
    try { txt = el.textContent || el.innerText || ""; } catch (e) { txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").trim();
  }

  function removeAudioButtonsFromClone(root) {
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn");
    for (var i = 0; i < btns.length; i++) {
      if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
    }
  }

  function splitIntoSpeechChunks(text, maxLen) {
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var size = maxLen || 210;
    var bits = src.match(/[^.!?;:]+[.!?;:]?|[^.!?;:]+$/g) || [src];
    var out = [];
    var acc = "";

    for (var i = 0; i < bits.length; i++) {
      var part = clampStr(bits[i]).trim();
      if (!part) continue;

      if (!acc) {
        acc = part;
        continue;
      }

      if ((acc + " " + part).length <= size) {
        acc += " " + part;
      } else {
        out.push(acc);
        if (part.length <= size) {
          acc = part;
        } else {
          var words = part.split(/\s+/);
          var line = "";
          for (var j = 0; j < words.length; j++) {
            var w = words[j];
            if (!line) line = w;
            else if ((line + " " + w).length <= size) line += " " + w;
            else {
              out.push(line);
              line = w;
            }
          }
          acc = line;
        }
      }
    }
    if (acc) out.push(acc);
    return out;
  }

  function getTargetRoots() {
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SEL) || []);
  }

  function getDetailBlocks(root) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(".po-lex-details") || []) : [];
  }

  function collectGeneralText(root) {
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i = 0; i < slots.length; i++) {
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(" ");
  }

  function collectBlockText(detail) {
    if (!detail) return "";
    var clone = detail.cloneNode(true);
    removeAudioButtonsFromClone(clone);
    clone.open = true;

    var parts = [];
    var summary = clone.querySelector(".po-lex-summary");
    if (summary) {
      var title = getTextValue(summary.querySelector(".po-lex-summary__title")) || getTextValue(summary);
      if (title) parts.push(title);
    }

    var bodyTexts = clone.querySelectorAll(".po-axis-wb__h, .po-axis-wb__t, .po-lex-example, .po-lex-table, .po-lex-list, .po-lex-def-short, .po-lex-def-long, p, li, td, th, .po-lex-family");
    for (var i = 0; i < bodyTexts.length; i++) {
      var txt = getTextValue(bodyTexts[i]);
      if (txt) parts.push(txt);
    }

    return parts.join(" ");
  }

  function getVoiceForLang(lang) {
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    if (!voices.length) return null;
    var L = normLang(lang) || "fr";
    var pref = { fr: ["fr", "fr-fr", "fr_ca"], en: ["en", "en-us", "en-gb"], es: ["es", "es-es", "es-mx"] }[L] || [L];

    for (var i = 0; i < pref.length; i++) {
      for (var j = 0; j < voices.length; j++) {
        var vlang = clampStr(voices[j].lang).toLowerCase();
        if (vlang.indexOf(pref[i]) === 0) return voices[j];
      }
    }
    return voices[0] || null;
  }

  function setAudioButtonState(root, activeKey, lang) {
    if (!root) return;
    var ui = audioUI(lang);
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var key = btn.getAttribute("data-po-audio-key") || "";
      var role = btn.getAttribute("data-po-audio-role") || "block";
      var playing = activeKey && key === activeKey;
      btn.classList.toggle("is-playing", !!playing);
      btn.textContent = playing ? ui.stop : (role === "general" ? ui.general : ui.block);
      btn.setAttribute("aria-pressed", playing ? "true" : "false");
    }
  }

  function resetAudioState() {
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
  }

  function stopAudio() {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    var roots = getTargetRoots();
    for (var i = 0; i < roots.length; i++) setAudioButtonState(roots[i], "", getLang());
    resetAudioState();
  }

  function speakCurrentChunk() {
    if (!PO_AUDIO_SYNTH) {
      resetAudioState();
      return;
    }

    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length) {
      PO_AUDIO_STATE.unitPos += 1;
      if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
        stopAudio();
        return;
      }

      var current = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      if (current && current.detail && !current.detail.open) current.detail.open = true;
      PO_AUDIO_STATE.chunks = splitIntoSpeechChunks(current.text, 210);
      PO_AUDIO_STATE.chunkPos = 0;
      if (!PO_AUDIO_STATE.chunks.length) {
        speakCurrentChunk();
        return;
      }
    }

    var utter = new SpeechSynthesisUtterance(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    utter.lang = (normLang(PO_AUDIO_STATE.lang) || "fr");
    if (utter.lang === "fr") utter.lang = "fr-FR";
    else if (utter.lang === "en") utter.lang = "en-US";
    else if (utter.lang === "es") utter.lang = "es-ES";

    PO_AUDIO_STATE.voice = getVoiceForLang(PO_AUDIO_STATE.lang);
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;

    utter.onend = function () {
      PO_AUDIO_STATE.chunkPos += 1;
      if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length) {
        PO_AUDIO_STATE.chunks = [];
        PO_AUDIO_STATE.chunkPos = 0;
      }
      speakCurrentChunk();
    };

    utter.onerror = function () {
      stopAudio();
    };

    try { PO_AUDIO_SYNTH.speak(utter); } catch (e) { stopAudio(); }
  }

  function buildUnitsFrom(root, startIndex) {
    var units = [];
    var generalText = collectGeneralText(root);
    if (generalText && (!startIndex || startIndex <= 0)) {
      units.push({ key: "general", text: generalText, detail: null });
    }

    var details = getDetailBlocks(root);
    var start = startIndex || 0;
    for (var i = start; i < details.length; i++) {
      var txt = collectBlockText(details[i]);
      if (txt) units.push({ key: "block-" + i, text: txt, detail: details[i] });
    }
    return units;
  }

  function startAudio(root, key, blockIndex) {
    if (!root) return;
    if (!PO_AUDIO_SYNTH) return;

    if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key) {
      stopAudio();
      return;
    }

    try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.lang = getLang();
    PO_AUDIO_STATE.units = buildUnitsFrom(root, blockIndex || 0);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = 0;
    PO_AUDIO_STATE.activeKey = key;

    setAudioButtonState(root, key, PO_AUDIO_STATE.lang);
    speakCurrentChunk();
  }

  function createAudioButton(role, key, blockIndex) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role);
    btn.setAttribute("data-po-audio-key", key);
    if (typeof blockIndex === "number") btn.setAttribute("data-po-audio-index", String(blockIndex));
    btn.addEventListener("click", function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var root = btn.closest(ROOT_SEL);
      if (!root) return;
      if (role === "general") startAudio(root, key, 0);
      else startAudio(root, key, blockIndex);
    });
    return btn;
  }

  function ensureAudioButtons(root, lang) {
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel) {
      var generalWrap = panel.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap) {
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");
        generalWrap.appendChild(createAudioButton("general", "general"));
        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector('[data-po-slot="def_short"]');
        if (meta && meta.parentNode === panel) {
          meta.insertAdjacentElement("afterend", generalWrap);
        } else if (defShort && defShort.parentNode === panel) {
          defShort.insertAdjacentElement("beforebegin", generalWrap);
        } else {
          panel.insertBefore(generalWrap, panel.firstChild);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i = 0; i < details.length; i++) {
      var summary = details[i].querySelector(".po-lex-summary");
      if (!summary) continue;
      var localWrap = summary.querySelector('.po-axis-audio-wrap[data-po-audio-role="block"]');
      if (!localWrap) {
        localWrap = document.createElement("span");
        localWrap.className = "po-axis-audio-wrap";
        localWrap.setAttribute("data-po-audio-role", "block");
        localWrap.appendChild(createAudioButton("block", "block-" + i, i));
        summary.appendChild(localWrap);
      }
    }

    setAudioButtonState(root, PO_AUDIO_STATE.root === root ? PO_AUDIO_STATE.activeKey : "", lang);
  }

  function initAudioEverywhere(lang) {
    var roots = getTargetRoots();
    for (var i = 0; i < roots.length; i++) ensureAudioButtons(roots[i], lang || getLang());
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "kicker", "def_short", "def_long", "grid_scope_value", "p_intro", "actions", "phrase", "table_rows",
      "entite_body", "ritual_steps", "moments", "syntony"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];
    var textSlots = [
      "title", "h_def", "chip_1", "chip_2", "chip_3", "h_grid", "grid_type_label", "grid_type_value",
      "grid_freq_label", "grid_freq_value", "grid_scope_label", "h_intro", "h_actions", "h_phrase",
      "h_table", "table_head_1", "table_head_2", "table_head_3", "h_entite", "entite_kicker",
      "h_ritual", "ritual_name_label", "ritual_name_value", "h_moments", "h_syntony", "cta_translate"
    ];

    for (var i = 0; i < textSlots.length; i++) {
      var txtEl = root.querySelector('[data-po-slot="' + textSlots[i] + '"]');
      if (txtEl) setText(txtEl, c[textSlots[i]]);
    }

    for (var j = 0; j < htmlSlots.length; j++) {
      var htmlEl = root.querySelector('[data-po-slot="' + htmlSlots[j] + '"]');
      if (htmlEl) setHTML(htmlEl, c[htmlSlots[j]]);
    }

    for (var k = 0; k < imgSlots.length; k++) {
      var imgEl = root.querySelector('[data-po-slot="' + imgSlots[k] + '"]');
      if (imgEl) setImg(imgEl, c[imgSlots[k]]);
    }

    syncChipBlock(root, "chip_1");
    syncChipBlock(root, "chip_2");
    syncChipBlock(root, "chip_3");

    applyHintText(root, lang);
    applyLangbar(root, lang);
    ensureAudioButtons(root, lang);
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || "fr";
    storeLang(safeLang);
    syncDocumentLang(safeLang);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK9CouleurEspaceInit) return;
    root.__poK9CouleurEspaceInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    syncDocumentLang(getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  window.PoK9CouleurEspaceTextsFR_EN_ES_20260318 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  if (typeof window !== "undefined" && window.speechSynthesis && window.speechSynthesis.onvoiceschanged !== undefined) {
    try {
      window.speechSynthesis.onvoiceschanged = function () {
        initAudioEverywhere(getLang());
      };
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();